<template>
  <div class="">
    <h4 v-t="'gateway.sep_pos.modal_title'"/>
    <img class="img-fluid" :src="`${findAttributeOnSiteInfo('host')[0]}/storage/pos/pos-terminal.gif`" alt="pos-image">
    
    <button class="btn btn-success d-none" id="btnSendAmountPCStart">Send Amount</button>
    <button class="btn btn-danger d-none" id="btnCancelTransaction">لغو تراکنش</button>
  </div>
</template>

<script>
import $ from 'jquery'
import signalR from './libs/jquery.signalR-2.4.2.min';
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import axios from "axios";

window.$ = $;
window.jQuery = $;

export default {
  name: "SepPos1",
  props: {
    posForm: {
      default: null
    }
  },
  methods: {
    findAttributeOnSiteInfo,
    loadScript(src) {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    startSignalR() {
      const hub = $.connection.SSP1126HUB;
      let serverMessage = '';
      let computerIp = findAttributeOnSiteInfo('computer_pos_ip_gate_info')[0]
      let posForm = this.posForm
      $.connection.hub.url = `${computerIp}/signalr`;

      hub.client.GetSystemResponse = function (msg) {
        serverMessage = msg;
      };

      hub.client.GetTransactionResponse = function (TerminalId, ResponseCode, SerialId, RRN, ResponseDescription, TxnDate, Amount, CardNumberMask) {
        if (ResponseCode == '00') {

          // post data to api then redirect user to verify.
          let form = {
            RRN: RRN,
            response_code: '00',
            card: CardNumberMask,
            serial_id: SerialId
          }

          axios.post(`${findAttributeOnSiteInfo('host')[0]}/api/verify-order-payment/order/${posForm.slug}?no_redirect=true`, form)
              .then(res => {
                location.href = `${findAttributeOnSiteInfo('site_link')[0]}/transaction/verify/order/${posForm.slug}`
              })


        } else {
          let shoppingCardSubmitButton = document.getElementById('shopping-card-submit-button');
          shoppingCardSubmitButton.disabled = false;
        }

        $('#pos-modal').modal('hide')
      };

      $.connection.hub.start().done(() => {
        $('#btnSendAmountPCStart').on('click', () => {
          serverMessage = '';
          $('#discussion').empty();
          let posIP = findAttributeOnSiteInfo('sep_pos_gate_info')[0]
          hub.server.Initial(1, posIP, 'COM4', '0', '0', '0');

          setTimeout(() => {
            if (serverMessage === '0') {
              let price = `${this.posForm.amount}0`
              hub.server.SendAmount1Step(price, null, undefined, undefined, undefined, undefined);
              hub.server
              $('#discussion').append('<li>Please swipe card...</li>');
            } else {
              $('#discussion').append('<li>Initialization error</li>');
            }
          }, 1000);

        });
        $('#btnCancelTransaction').on('click', () => {
          hub.server.Reset();
        });
      });
    },
    sendRequestToPos() {
      document.querySelector('#btnSendAmountPCStart').click()
    }
  },
  mounted() {
    let computerIp = findAttributeOnSiteInfo('computer_pos_ip_gate_info')[0]
    this.loadScript(`${computerIp}/signalr/hubs`)
        .then(() => this.startSignalR())
        .catch((e) => {
          console.error("خطا در بارگذاری اسکریپت‌ها:", e);
        });

    $('#pos-modal').on('hidden.bs.modal', function (event) {
      let shoppingCardSubmitButton = document.getElementById('shopping-card-submit-button');
      shoppingCardSubmitButton.disabled = false;
      document.querySelector('#btnCancelTransaction').click()
    })

  },
  watch: {
    'posForm.slug': {
      handler(value) {
        setTimeout(() => {
          this.sendRequestToPos()
        }, 100)
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  }
}
</script>
